import { render, staticRenderFns } from "./DueAmendmentStep.vue?vue&type=template&id=5899cb43&"
import script from "./DueAmendmentStep.vue?vue&type=script&lang=js&"
export * from "./DueAmendmentStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports